'use strict';

var AdjustEffectiveFaresPanelDirective = function AdjustEffectiveFaresPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'AdjustEffectiveFaresPanelController',
    template: require('../templates/adjust-effective-fares-panel.html'),
    scope: {
      recommendationEntry: '=',
      screenState: '='
    }
  };
};
AdjustEffectiveFaresPanelDirective.$inject = [];
module.exports = AdjustEffectiveFaresPanelDirective;